import type { HtmlSerializerProps } from '../../utils/html-serializer';
import htmlSerializer from '../../utils/html-serializer';

import type { BrazeCustomEvent } from './prescreen-consumer';

interface CustomPrescreenProps {
  content: HtmlSerializerProps['content'][];
  onClose: () => void;
  onURLButtonClick: (
    url: string,
    target?: '_self' | '_blank',
    buttonId?: string
  ) => void;
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'overlay'
    | 'tertiary'
    | 'proBusiness'
    | 'premium'
    | 'proJobs';
  sendBrazeCustomEvent?: (payload: BrazeCustomEvent) => void;
}

const CustomPrescreen: React.FC<CustomPrescreenProps> = ({
  content,
  onClose,
  onURLButtonClick,
  sendBrazeCustomEvent,
  buttonColor,
}) => {
  return (
    <>
      {content.map((content, index) =>
        htmlSerializer({
          content,
          key: `customHTML-${index}`,
          onClose,
          onURLButtonClick,
          buttonColor,
          sendBrazeCustomEvent,
        })
      )}
    </>
  );
};

export default CustomPrescreen;
